import { redeemToken, RedemptionError, RedemptionRequest, RedemptionResult } from '@api/redemption';
import { useMutation } from '@tanstack/react-query';

export const useRedeemToken = () => {
  return useMutation<RedemptionResult, RedemptionError, RedemptionRequest>({
    mutationFn: redeemToken,
    // Let the callable fail with a bounded error while offline instead of
    // pausing indefinitely and submitting automatically on reconnect.
    networkMode: 'always',
    retry: false,
  });
};
